export default __webpack_public_path__ + "static/media/teachers-and-kids-coloring_book.031dc802.jpg";